import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-grid-spinner',
  templateUrl: './grid-spinner.component.html',
  styleUrls: ['./grid-spinner.component.scss']
})
export class GridSpinnerComponent implements OnInit {

  message = 'Loading...';
  isVisible = false;

  constructor() { }

  ngOnInit() {
  }

  public showSpinner(message: string = 'Loading...') {
    this.message = message;
    this.isVisible = true;
  }

  public hideSpinner() {
    this.isVisible = false;
  }

  public showPrompt() {

  }

  public showError() {

  }

  public showMessage(message: string, timeout: number) {
    this.message = message;
    this.isVisible = true;
    if (timeout > 0) {
      setTimeout(() => {
        this.isVisible = false;
      }, timeout);
    }
  }
}

